import React from 'react';
import css from './SectionAuth.css';
import { HorseDealCreateAccountTeaser } from '../../../../components';
import { useSelector } from 'react-redux';
import { getDefaultList } from '../../../../components/HorseDealCreateAccountTeaser/getDefaultList';

export default () => {
    const currentUser = useSelector(state => state.user.currentUser);

    if (!!currentUser?.id?.uuid) {
        return null;
    }

    const benefitsList = getDefaultList();

    const texts = [
        'Entdecke relevante Reiter- und \nPferde-Profile in deiner Nähe.',
        'Finde dank unseren Matching heraus, wie \ngut Pferd oder Reiter:in passt.',
        'Finde befristete oder langfriste Aushilfen, \ndamit Du zeitlich flexibel bleibst.',
        'Nimm an exklusiven Gewinnspielen teil und erhalte tolle Prämien.',
    ];

    return (
        <section className={css.root}>
            <div>
                <HorseDealCreateAccountTeaser
                    title="Finde dein Match"
                    benefits={benefitsList.map((benefitItem, index) => ({
                        ...benefitItem,
                        text: <p>{texts[index]}</p>,
                    }))}
                    benefitsWrapperClassName={css.benefitsWrapper}
                    extraFields={{
                        privateData: {
                            registeredViaFlipAndWin: true,
                        },
                    }}
                />
            </div>
        </section>
    );
};
